<template>
  <section class="formcta">
    <div class="formcta__content container">
      <a href="https://lu.ma/dnafund" target="_blank">
        <button class="formcta__btn presenter-btn">{{ buttonText }}</button>
      </a>
    </div>
  </section>
</template>

<style lang="scss" scoped type="text/css">
@import "@/styles/components/formcta.scss";
</style>

<script>

export default {
  name: "generalformcta",
  props: {
    buttonText: {
      type: String,
      default: 'Register Here'
    }
  },
  data() {
    return {
      generalModal: false,
    };
  },
  methods: {
    showModal() {
      this.generalModal = true
      document.body.classList.add('modal-open');
    },
    hideModal() {
      this.generalModal = false;
      document.body.classList.remove('modal-open');
    }
  }
};
</script>
